import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/generic/token.service';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor{

    constructor(){
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        const token = TokenService.getTokenAC;
        const tokenC = TokenService.getTokenC;
        const withToken = request.params.get('token');
        if( !['false'].includes(withToken) && token && tokenC ) {
            const updatedRequest = request.clone({
                setHeaders: TokenService.headersToken,
            })
            return next.handle(updatedRequest)
        } else {
            const modifiedRequest = request.clone();
            const params = modifiedRequest.params;
            params['map'].delete('token');
            params.delete('token');
            const finalRequest = modifiedRequest.clone({ params });
            
            return next.handle(finalRequest);
        }
    }
}